import React from 'react'
import PropTypes from 'prop-types'
import {Button, Img, Text} from '@chakra-ui/react'
import {getGlobalLink} from '../../../utils/contentstack-utils'
import {remCalc} from '../../../theme/_utils'

export const desktopOnlyDisplay = {base: 'none', sm: 'none', md: 'flex'}
export const mobileOnlyDisplay = {base: 'flex', sm: 'flex', md: 'none'}
export const templateGridGap = {base: remCalc(32), sm: remCalc(32), md: remCalc(24)}
// in order to avoid chagning the size of the image and to avoid overflow
export const templateGridGapSx = {
    '@media screen and (min-width: 768px) and (max-width: 785px)': {
        gap: remCalc(12),
    },
}
export const compactGap = {base: 'xsmall.base', sm: 'xsmall.base', md: 'xsmall-1.base'}
export const drawerBottomPadding = {
    base: remCalc(64),
    sm: remCalc(64),
    md: 'unset',
    lg: 'unset',
}
export const fullHeightChildSx = {
    '& > div': {
        height: '100%',
        minHeight: '100%',
    },
}
export const groupedCategoriesProps = {
    textAlign: {md: 'left'},
}

export const DrawerLinkButtons = ({links, categoryData, locale, styles}) =>
    links.map((link, idx) => {
        const {label, url, isAbsolute} =
            getGlobalLink({
                link: link?.link,
                categoriesData: categoryData,
                locale: locale?.alias,
            }) || {}

        return (
            <Button
                key={`drawer-menu-icon-link-button-${idx}`}
                leftIcon={
                    link?.icon?.url ? <Img boxSize={remCalc(20)} src={link.icon.url} /> : undefined
                }
                as="a"
                href={url}
                isExternal={isAbsolute}
                variant="ghost"
                justifyContent="flex-start"
                px="0"
                py={remCalc(4)}
                minH="auto"
                h="auto"
                textAlign="left"
            >
                <Text {...styles?.iconLinkText}>{label}</Text>
            </Button>
        )
    })

DrawerLinkButtons.propTypes = {
    links: PropTypes.array.isRequired,
    categoryData: PropTypes.object,
    locale: PropTypes.object,
    styles: PropTypes.object,
}

export const drawerTemplatePropTypes = {
    primarycategory: PropTypes.object,
    categoryData: PropTypes.object,
    locale: PropTypes.object,
    styles: PropTypes.object,
}
